export const BUILD_VERSION = {
  "buildNumber": 125,
  "buildDate": "2026_07_07",
  "version": "00125/2026_07_07",
  "releaseVersion": "v1.0.20"
};